export enum AppName {
  Novartis = 'novartis_live',
  NuclearGames = 'nuclear_games',
  Danioth = 'danioth',
}
